<template>
  <section class="page-title">
    <div class="container">
      <div class="page-title-icon" v-if="img">
        <img :src="
              require(`@/assets/images/${img}`)
            " alt="icon" :class="imgClass" />
      </div>
      <h1 class="page-title-heading">{{ title }}</h1>
      <div
        class="page-title-info"
        v-if="info"
        :class="infoClass"
        v-html="info"
        v-setlinks
      ></div>
      <div class="page-title-text" v-if="text" v-html="text"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "page-title",
  props: {
    img: String,
    imgClass: String,
    title: String,
    text: String,
    info: String
  }
};
</script>